import { createSlice } from "@reduxjs/toolkit";
import { getRooms } from "./_roomAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const roomList = createSlice({
  name: "roomList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getRooms.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getRooms.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getRooms.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
